/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


// Collection template filter AJAX
function applyFilter(filterUrl) {
  if(filterUrl.includes('collections')) {

    const sectionUrl = filterUrl;
        console.log('this is working', sectionUrl);
    fetch(sectionUrl)
      .then(response => {
          if (!response.ok) {
              throw new Error('Network response was not ok');
          }
          return response.text();
      })
      .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newSection = doc.querySelector('[data-grid-container], .collection');
          const currentSection = document.querySelector('[data-grid-container], .collection');
          if (currentSection && newSection) {
              currentSection.innerHTML = newSection.innerHTML;
          }
          prodGridATC();
          handleResizeQuickAdd();
      })
      .catch(error => {
          console.error('Error fetching the filtered section:', error);
      });
  }
}

const collectionFilterBtnActive = () => {
  const filterBtns = document.querySelectorAll('.column__item--filter');

  filterBtns.forEach(filterBtn => {
    filterBtn.addEventListener('click', () => {
      // window.dispatchEvent(new Event('resize'));
      filterBtns.forEach(btn => {
        if(btn.classList.contains('button-active')) {
          btn.classList.remove('button-active');
        }
      })

      filterBtn.classList.add('button-active');

    })
  })
}
document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector('.template-collection')) {
      collectionFilterBtnActive();
  }
});


let rebuyCartShownOnce = sessionStorage.getItem('rebuyCartShownOnce') === 'true';
let smartCartInProgress = false;
let lastCartOpenTime = 0;

document.addEventListener('rebuy:smartcart.show', function () {
  const now = Date.now();

  if (rebuyCartShownOnce || smartCartInProgress || (now - lastCartOpenTime < 1000)) {
    console.log('[Rebuy Smart Cart] Ignored event: already handled or triggered too soon.');
    return;
  }

  lastCartOpenTime = now;
  smartCartInProgress = true;
  console.log('[Rebuy Smart Cart] Show event triggered. Watching for checkbox...');

  const timeoutLimit = 5000;
  let clicked = false;

  const observer = new MutationObserver(() => {
    const checkbox = document.querySelector('#sca-cart-addon input');

    if (checkbox) {
      console.log('[Rebuy Smart Cart] Checkbox found.');

      if (!checkbox.checked && !clicked) {
        clicked = true;

        checkbox.dispatchEvent(new MouseEvent('click', {
          view: window,
          bubbles: true,
          cancelable: true
        }));

        console.log('[Rebuy Smart Cart] Checkbox was unchecked. Simulated click.');
        rebuyCartShownOnce = true;
        sessionStorage.setItem('rebuyCartShownOnce', 'true');

        observer.disconnect();
        clearTimeout(fallbackTimeout);
        smartCartInProgress = false;
      } else if (checkbox.checked) {
        console.log('[Rebuy Smart Cart] Checkbox already checked. No click needed.');
        observer.disconnect();
        clearTimeout(fallbackTimeout);
        rebuyCartShownOnce = true;
        sessionStorage.setItem('rebuyCartShownOnce', 'true');
        smartCartInProgress = false;
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  const fallbackTimeout = setTimeout(() => {
    observer.disconnect();
    smartCartInProgress = false;
    console.warn('[Rebuy Smart Cart] Timeout: Checkbox not found or never stabilized.');
  }, timeoutLimit);
});


const prodGridATC = () => {
  const prodGridItems = document.querySelectorAll('.product-grid-item');

  prodGridItems.forEach(item => {
    let form = item.querySelector('.form');
    let btnCtr = item.querySelector('.product__submit__item');
    let atcBtn = item.querySelector('.btn--quick-add');
    let options = item.querySelectorAll('input[type="radio"]');
    let variantsCtr = item.querySelector('.product-grid-item__quick-atc--variants');

    function expand() {
      atcBtn.classList.remove('btn--disabled');
      variantsCtr.classList.add('expand-options');
    }

    function collapse() {
      atcBtn.classList.add('btn--disabled');
      variantsCtr.classList.remove('expand-options');
    }

    if(btnCtr && atcBtn) {
      btnCtr.addEventListener('click', () => {
        expand();
      })

      form.addEventListener('mouseover', () => {
        expand();
      })

      atcBtn.addEventListener('click', () => {
        collapse()
      })

      form.addEventListener('mouseout', () => {
        collapse()
      })

      form.addEventListener('focusin', () => {
        expand();
      })

      form.addEventListener('focusout', (e) => {
        if (!form.contains(e.relatedTarget)) {
          collapse()
        }
      })
    }
  
  })
}
document.addEventListener("DOMContentLoaded", () => {
  if (document.querySelector('.product-grid-item')) {
      prodGridATC();
  }
});

const prodSubmitCard = () => {
  const prodGridItems = document.querySelectorAll('.bd-product-card');
  if(prodGridItems.length < 1) return;

  prodGridItems.forEach(prod => {
    const prodVariants = prod.querySelector('bd-card-submit');
    const upsellBtnWrapper = prod.querySelector('.upsell-btn-wrapper');
    const quickAddBtn = prod.querySelector('.upsell-btn');
    const variants = prod.querySelector('bd-variants');

    if(!prodVariants || !variants) return;

    prodVariants.addEventListener('mouseover', () => {
      upsellBtnWrapper.classList.add('active');
      quickAddBtn.classList.add('active');
      variants.classList.add('active');
    })

    prodVariants.addEventListener('mouseout', () => {
      upsellBtnWrapper.classList.remove('active');
      quickAddBtn.classList.remove('active');
      variants.classList.remove('active');
    })

    prodVariants.addEventListener('focusin', () => {
      upsellBtnWrapper.classList.add('active');
      quickAddBtn.classList.add('active');
      variants.classList.add('active');
    })

    prodVariants.addEventListener('focusout', (e) => {
      if (!prodVariants.contains(e.relatedTarget)) {
        upsellBtnWrapper.classList.remove('active');
        quickAddBtn.classList.remove('active');
        variants.classList.remove('active');
      }
    })
  })
}

const prodSubmitCardMobile = () => {
  const prodGridItems = document.querySelectorAll('.bd-product-card');
  if(prodGridItems.length < 1) return;

  prodGridItems.forEach(prod => {
    const quickAddBtn = prod.querySelector('.upsell-btn');
    const variants = prod.querySelector('bd-variants');

    if(!quickAddBtn) return;

    quickAddBtn.addEventListener('click', (e) => {
      if (quickAddBtn.classList.contains('active') && variants.classList.contains('active')) {
        setTimeout(() => {
          quickAddBtn.classList.remove('active');
          variants.classList.remove('active');
        }, 100);
      } else if (!quickAddBtn.classList.contains('active') && !variants.classList.contains('active')) {
        e.preventDefault();
        e.stopImmediatePropagation();
        quickAddBtn.classList.add('active');
        variants.classList.add('active');
        return false;
      }
    }, true)
  })
}


const handleResizeQuickAdd = () => {
  if (window.innerWidth < 767) {
    prodSubmitCardMobile();
  } else {
    prodSubmitCard();
  }
}

handleResizeQuickAdd();
document.addEventListener('shopify:section:load', handleResizeQuickAdd);
window.addEventListener('resize', handleResizeQuickAdd);

if(document.querySelector('.template-product')) {
  const observer = new MutationObserver(() => {
    if(document.querySelectorAll('.bd-product-card').length > 0) {
      handleResizeQuickAdd();
      observer.disconnect();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}


function waitForElements(selector) {
  return new Promise(resolve => {
      if (document.querySelectorAll(selector).length > 0) {
          return resolve(document.querySelectorAll(selector));
      }

      const observer = new MutationObserver(mutations => {
          if (document.querySelectorAll(selector).length > 0) {
            resolve(document.querySelectorAll(selector));
            observer.disconnect();
          }
      });

      observer.observe(document.body, {
          childList: true,
          subtree: true
      });
  });
}

Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

(function() {
  // Add custom code below this line

  

  function getOffsetTop( elem )
  {
      var offsetLeft = 0;
      do {
        if ( !isNaN( elem.offsetTop ) )
        {
            offsetLeft += elem.offsetTop;
        }
      } while( elem = elem.offsetParent );
      return offsetLeft;
  }
  
  let categoryBreakdown = document.querySelector('.cat-breakdown');
  
  if (categoryBreakdown) {
    let categoryBreakdownTrigger = categoryBreakdown.querySelector('.cat-breakdown__item');
    let categoryBreakdownBack = categoryBreakdown.querySelector('.cat-breakdown__back');
    let categoryBreakdownTexts = categoryBreakdown.querySelector('.cat-breakdown__texts');

    let categoryBreakdownDescription = categoryBreakdown.querySelector('.cat-breakdown__description');
    let categoryBreakdownDescriptionHeight = categoryBreakdownDescription.scrollHeight;
    categoryBreakdownDescription.style.setProperty('--description-height', categoryBreakdownDescriptionHeight + 'px');


    const syncCategoryBreakdownExpanded = () => {
      const isExpanded = categoryBreakdown.classList.contains('cat-breakdown--expanded');
      categoryBreakdownTrigger.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
    };

    syncCategoryBreakdownExpanded();

    categoryBreakdownTrigger.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      categoryBreakdown.classList.toggle('cat-breakdown--expanded');
      syncCategoryBreakdownExpanded();

      return false;
    });

    categoryBreakdownBack.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      categoryBreakdown.classList.toggle('cat-breakdown--expanded');
      syncCategoryBreakdownExpanded();

      return false;
    });
  }

  
  let images = document.querySelectorAll('.image-with-text__image--rotate');

  const updateImagesRotation = () => {
    images.forEach(function(image, i) {
      let imageHeight = image.scrollHeight;
      let imageTop = getOffsetTop(image);
      let imageBottom = imageTop + (imageHeight / 2);
      
      // get scroll position percentage of image
      let scrollPosition = window.scrollY;
      let scrollPositionPercentage = (scrollPosition - imageTop) / (imageBottom - imageTop);
      let rotationMin = parseInt(image.dataset.rotationStart);
      let rotationMax = 0;
      let rotation = rotationMin + (rotationMax - rotationMin) * scrollPositionPercentage;

      if (rotationMin > 0 && rotation < 0) {
        rotation = 0;
      } else if (rotationMin < 0 && rotation > 0) {
        rotation = 0;
      }
      image.style.setProperty('--rotation', rotation + 'deg');
    });
  }

  if (images) {
    updateImagesRotation();
    window.addEventListener('scroll', function(e) {
      updateImagesRotation();
    });
  }

  const updateVariantDisplay = (newState, subscriptionData = false) => {
    let variant = newState.variant;
    let plan = newState.formState.plan;
    let variantPrice = variant.price;
    let variantName = variant.title;
    let productPriceVariant = document.querySelector('.product__price--variant');
   // let productATCPrice = document.querySelector('.product__atc-price');
    let productPrice = document.querySelector('[data-product-price]');
    let productComparePrice = document.querySelector('.product__price--compare');
    let productSaleTag = document.querySelector('.product__price--off');

    window.currentProductState = newState;
    if (subscriptionData) {
      let { planType, customPrice, customComparePrice } = subscriptionData;
     // productATCPrice.innerHTML = `- ${customPrice}`;
      productPrice.innerHTML = customPrice;

      if (planType == 'subscription') {
        productComparePrice.classList.remove('hidden');
        productSaleTag.classList.remove('hidden');
        productComparePrice.innerHTML = customComparePrice;
      } else {
        productComparePrice.classList.add('hidden');
        productSaleTag.classList.add('hidden');
      }
    } else {
      if (plan) {
        let { price, compare_at_price } = plan.allocation;
       // productATCPrice.innerHTML = `- ${Shopify.formatMoney(price)}`;
      } else {
       // productATCPrice.innerHTML = `- ${Shopify.formatMoney(variantPrice)}`;
      }
    }

    if (!!productPriceVariant) {
      productPriceVariant.innerHTML = `for ${variantName}`;
    }
  }


  document.addEventListener('theme:variant:change', function(e) {
    updateVariantDisplay(e.detail);
  });

  waitForElements('.rc-radio__input').then(function(elements) {
    elements.forEach(function(element) {
      element.addEventListener('change', function(e) {
        if (document.querySelector('radio__input')) {
          let currentRadioChecked = document.querySelector('.radio__input:checked');
          let firstRadio = document.querySelector('.radio__input:not(:checked)');
          firstRadio.checked = true;
          currentRadioChecked.checked = true;
          currentRadioChecked.dispatchEvent(new Event('change'));
        } else {
          let currPriceLabel = element.closest('.rc-radio').querySelector('.price-label');
          let allPriceLabels = element.closest('.rc-button-group__options').querySelectorAll('.price-label');
          let comparePriceLabel = false;

          allPriceLabels.forEach(function(priceLabel) {
            if (priceLabel != currPriceLabel) {
              comparePriceLabel = priceLabel;
            }
          });

          updateVariantDisplay(window.currentProductState, {
            customPrice: currPriceLabel.innerHTML,
            customComparePrice: comparePriceLabel.innerHTML,
            planType: element.value
          });
        }
      });
    });
  });



  // popup 

  setTimeout(function() {
    const modal = document.getElementById("myModal");
    const productTitle = document.querySelector(".product-title-sca");
    const closeBtn = document.querySelector(".close");
    
    if (!productTitle) return;

    let modalLastFocused = null;

    const onModalKeydown = function(event) {
      if (event.key === "Escape") {
        hideModal();
      }
    };

    function showModal() {
      modalLastFocused = document.activeElement;
      modal.style.display = "block";
      document.addEventListener("keydown", onModalKeydown);

      const focusTarget = closeBtn || modal;
      if (focusTarget === modal && !modal.hasAttribute("tabindex")) {
        modal.setAttribute("tabindex", "-1");
      }
      if (focusTarget && typeof focusTarget.focus === "function") {
        focusTarget.focus();
      }
    }

    function hideModal() {
      modal.style.display = "none";
      document.removeEventListener("keydown", onModalKeydown);
      if (modalLastFocused && typeof modalLastFocused.focus === "function") {
        modalLastFocused.focus();
      }
      modalLastFocused = null;
    }

    // Open modal when clicking .product-title-sca
    productTitle.addEventListener("click", function(event) {
      // Get mouse position relative to element
      const rect = productTitle.getBoundingClientRect();
      const offsetX = event.clientX - rect.left;

      // Get width of the element
      const width = rect.width;

      // Assume ::after is positioned at right side (e.g., 20px wide)
        showModal();
    });

    // Close modal
    closeBtn.addEventListener("click", function() {
      hideModal();
    });

    // Close modal on click outside
    window.addEventListener("click", function(event) {
      if (event.target == modal) {
        hideModal();
      }
    });
  }, 2000); // 2000 milliseconds = 2 seconds

/* works but buggy 
let rebuyCartShownOnce = sessionStorage.getItem('rebuyCartShownOnce') === 'true';

document.addEventListener('rebuy:smartcart.show', function () {
  if (!rebuyCartShownOnce) {
    const checkbox = document.querySelector('#sca-cart-addon input'); // Replace with actual selector
    if (checkbox && !checkbox.checked) {
      checkbox.click(); // Simulate user click
    }
    rebuyCartShownOnce = true;
    sessionStorage.setItem('rebuyCartShownOnce', 'true'); // Store in sessionStorage
  }
});
*/

  document.addEventListener('DOMContentLoaded', function() {
    if(document.querySelector('.template-product .accordions-section')) {
      document.querySelector('.accordions-section .accordion__item--first button').click();
    }
  });
  

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();


